// extracted by mini-css-extract-plugin
export default {"collectionContainer":"collection_collectionContainer__bbC6l","cardGrid":"collection_cardGrid__cER7W"};